<template>
    <div class="container-fluid h-100">
        <div class="row g-0 h-100">
            <div class="col-12">
                <div class="login-wrapper" v-if="consent_status">
                    <form @submit.prevent="login">
                        <div class="login-screen">
                            <div class="login-body">
                                <div class="login-head">
                                    <a href="#" class="login-logo">
                                        <img src="../../assets/ultratech-cement-logo.png" alt="Logo" />
                                    </a>
                                    <h3 class="text-dark">digiCHECK</h3>
                                    <h6>
                                        Welcome back,<br />
                                        Please login to your account.
                                    </h6>
                                </div>
                                <div class="field-wrapper">
                                    <input id="email" type="email" class="form-control"
                                        :class="{ 'is-invalid': errors.email }" placeholder="Enter Email ID"
                                        v-model="user.email" ref="email" />
                                    <span v-if="errors.email" class="invalid-feedback">{{ errors.email[0] }}</span>
                                    <div class="field-placeholder">Email ID <span class="text-danger">*</span></div>
                                </div>
                                <div class="field-wrapper">
                                    <input id="password" type="password" class="form-control"
                                        :class="{ 'is-invalid': errors.password }" placeholder="Enter Password"
                                        v-model="user.password" />
                                    <span v-if="errors.password" class="invalid-feedback">{{ errors.password[0]
                                        }}</span>
                                    <div class="field-placeholder">Password <span class="text-danger">*</span></div>
                                </div>
                                <div class="actions" style="padding-bottom: 10px;">
                                    <button id="login" type="submit" class="btn btn-primary">Login</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="login-wrapper" v-else>
                    <div class="login-screen screen1">
                        <div class="login-body">
                            <div class="login-head">
                                <a href="#" class="login-logo">
                                    <img src="../../assets/ultratech-cement-logo.png" alt="Logo" />
                                </a>
                                <h3 class="text-dark">digiCHECK</h3>
                                <h5><b>Consent Form</b></h5>
                            </div>
                            <p class="text-align-justify mb-2">
                                UltraTech Cement (“<b>UltraTech</b>”) shall collect, use, store, transfer, or otherwise
                                process your Personal Data such as <b>name, mobile/contact number, email id</b> for the
                                purposes of
                                <b>digiCHECK application login authentication, work flow management and communication of
                                    alerts and deviations, (“Permitted Purpose”).</b>
                            </p>
                            <p class="text-align-justify mb-2">
                                If you wish to withdraw/rescind your consent to the usage of your Personal Data for the
                                Permitted Purpose, you may do so by clicking on [PROFILE&gt;REMOVE CONSENT] or informing
                                [Super Admin] at
                                [digichecksupport@akxatech.com]. Upon withdrawal of your consent, UltraTech shall cease
                                all processing of your Personal Data with respect to the Permitted Purpose.
                            </p>
                            <!-- <p class="text-align-justify mb-2">
                                You can review and update your Personal Data provided to UltraTech by sending an email to [digichecksupport@akxatech.com] or click on [USER&gt;DETAILS&gt;LINK] after logging into the web tool.
                            </p> -->
                            <p class="text-align-justify mb-2">
                                <span><input type="checkbox" class="chkhgt me-2" v-model="user.consent.consent"
                                        :value="user.consent.consent" /></span>I, the undersigned, have read the Consent
                                Form above and fully understand contents
                                thereof. By checking the “<b>CONSENT</b>” option and by pressing the “<b>ACCEPT</b>”
                                button, I do hereby consent to UltraTech, its affiliates and service providers to
                                collect, store, use and process my
                                Personal Data for the Permitted Purpose in the manner set out above.
                            </p>
                            <div class="text-end mb-3">
                                <button type="button" :disabled="!user.consent.consent" class="btn btn-sm btn-primary"
                                    @click="submit">Accept</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            user: {
                email: "",
                password: "",
                consent: {
                    consent: false,
                    consent_id: "",
                },
                user_id: "",
            },
            user_response: {
                email: "",
                password: "",
                user_id: "",
            },
            consent_status: true,
            errors: [],
        };
    },

    mounted() {
        this.$refs.email.focus();
    },

    methods: {
        login() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("auth", { uri: "login", data: vm.user })
                .then(function (response) {
                    console.log("res", response)
                    loader.hide();
                    vm.user_response = response.data;
                    if (vm.user_response?.consent?.consent == 0 || vm.user_response?.consent == null) {
                        vm.consent_status = false;
                    } else {
                        vm.$store.dispatch("success", "Successfully logged in");
                        vm.getPermissions();
                    }
                })
                .catch(function (error) {
                    loader.hide();
                    if (error.response.data.message == "Too Many Attempts.") {
                        vm.errors = { email: ["Too Many Attempts, Login after sometimes"] };
                    } else {
                        vm.errors = error.response.data.errors;
                    }
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },

        getPermissions() {
            let vm = this;
            vm.$store.dispatch("setUser", vm.user_response);
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("post", { uri: "getAbilities", data: vm.$store.getters.user })
                .then(function (response) {
                    loader.hide();
                    vm.$store.dispatch("setPermissions", response.data);
                    location.reload();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        submit() {
            let vm = this;
            let loader = vm.$loading.show();
            let data = {
                consent: vm.user.consent.consent,
                user_id: vm.user_response.user_id,
            };
            vm.$store
                .dispatch("auth", { uri: "addConsent", data: data })
                .then(function (response) {
                    loader.hide();
                    vm.user_response.consent = response.data.consent;
                    if (response.data.consent?.consent) {
                        vm.getPermissions();
                    }
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
    },
};
</script>
<style scoped>
.screen1 {
    min-width: 700px;
    max-width: 700px;
}

.text-align-justify {
    text-align: justify;
}

.login-screen .login-logo img {
    width: 180px;
    height: 60px !important;
}
</style>